import { Button } from "primereact/button";
import React, { ReactNode, useEffect, useState } from "react";
import "./mobile-modal-styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { classNames } from "primereact/utils";

export interface CustomModalProps {
  isOpen: boolean;
  header: string;
  onClose(): void;
  confirmation?: boolean;
  onConfirm?(): void;
  onSecondary?(): void;
  confirmationButtonText?: string;
  secondaryButtonText?: string;
  body?: ReactNode | string;
  centered?: boolean;
  justified?: boolean;
  width?: string;
  height?: string;
}

export function CustomModal({
  isOpen,
  onClose,
  onConfirm,
  onSecondary,
  confirmationButtonText,
  secondaryButtonText,
  body,
  centered,
  justified,
  header: title,
  confirmation = false,
  width,
  height,
}: CustomModalProps) {
  const [isVisible, setIsVisible] = useState<boolean>();

  useEffect(() => {
    setIsVisible(true);
  }, [isOpen]);

  const closeModal = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 200);
  };

  const backgroundClick = (e: any) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };
  return (
    <>
      {isOpen && (
        <div
          onClick={backgroundClick}
          className={classNames(
            "bg-dialog-blur card-wrapper",
            isVisible ? "grey-in" : "grey-out",
            centered ? "centered" : "",
            justified ? "justified" : ""
          )}
        >
          <div
            style={{ width: width, height: height }}
            className={classNames(
              "card w-full",
              isVisible ? "slide-up" : "slide-down"
            )}
          >
            <div className="header">
              <div className="title">{title}</div>
              <div className="close-btn cursor-pointer">
                <FontAwesomeIcon icon={faXmark} onClick={closeModal} />
              </div>
            </div>
            <div className="body">{body}</div>
            {confirmation && (
              <div className="footer">
                <Button
                  className="p-button"
                  severity="warning"
                  type="button"
                  onClick={closeModal}
                >
                  Anuluj
                </Button>
                <Button
                  onClick={onConfirm}
                  className="p-button"
                  type="button"
                  severity="success"
                >
                  {confirmationButtonText ?? "Potwierdź"}
                </Button>
                {onSecondary && (
                  <Button onClick={onSecondary} type="button">
                    {secondaryButtonText || "N/A"}
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
